import { SIGNUP_SUB_FLOW } from '@bingads-webui-campaign-react/shared-app-capi';
import { PMAX_LITE_WIZARD_STEP_PATHS, PREVIEW_TO_NON_PREVIEW_MAPPING, NON_PREVIEW_TO_PREVIEW_MAPPING } from './constants';

export const getFlow = ({
  isSmartPage,
  isSmartPageCustomDomainSupported,
  isSkipCampaign,
  isGoogleImport,
  isFacebookImport,
  isChinaSignup,
  psd2Country,
  isPreviewFlow,
  isCollectBusinessInfo,
} = {}) => {
  const initialStep = isCollectBusinessInfo ? [
    PMAX_LITE_WIZARD_STEP_PATHS.COLLECT_BUSINESS_INFO,
    PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_CREATION_METHOD,
  ] : [
    PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_CREATION_METHOD,
  ];

  const languageAndWebsiteStep = isCollectBusinessInfo ? [] : [
    PMAX_LITE_WIZARD_STEP_PATHS.LANGUAGE_COUNTRY,
    PMAX_LITE_WIZARD_STEP_PATHS.WEBSITE,
  ];

  const paymentStep = isPreviewFlow
    ? PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_PAYMENT
    : PMAX_LITE_WIZARD_STEP_PATHS.PAYMENT;

  const addFundsStep = isPreviewFlow
    ? PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ADD_FUNDS
    : PMAX_LITE_WIZARD_STEP_PATHS.ADD_FUNDS;

  // psd2Country will be set if user choose prepay + credit card + pds2Country (Eg. Germany)
  const paymentSteps = psd2Country ? [
    paymentStep,
    addFundsStep,
  ] : [
    paymentStep,
  ];

  const accountStep = isPreviewFlow
    ? PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ACCOUNT
    : PMAX_LITE_WIZARD_STEP_PATHS.ACCOUNT_DETAILS;

  const campaignCreationSteps = isPreviewFlow ? [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ASSETS] : [
    PMAX_LITE_WIZARD_STEP_PATHS.AD_ASSETS,
    PMAX_LITE_WIZARD_STEP_PATHS.TARGETING,
    PMAX_LITE_WIZARD_STEP_PATHS.BUDGET,
  ];

  if (isFacebookImport) {
    return [
      ...initialStep,
      PMAX_LITE_WIZARD_STEP_PATHS.FACEBOOK_IMPORT,
    ];
  }

  if (isGoogleImport) {
    return [
      ...initialStep,
      PMAX_LITE_WIZARD_STEP_PATHS.GOOGLE_IMPORT,
    ];
  }

  if (isChinaSignup) {
    return [
      PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_CREATION_METHOD,
      accountStep,
    ];
  }

  // collect business info step will never set isSmartPage to true
  if (isSmartPage) {
    if (isSmartPageCustomDomainSupported) {
      return [
        PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_CREATION_METHOD,
        PMAX_LITE_WIZARD_STEP_PATHS.LANGUAGE_COUNTRY,
        PMAX_LITE_WIZARD_STEP_PATHS.WEBSITE,
        PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_SIGNUP,
        PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_EDITOR,
        PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_CUSTOM_DOMAIN,
        ...campaignCreationSteps,
        accountStep,
        ...paymentSteps,
      ];
    }
    return [
      PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_CREATION_METHOD,
      PMAX_LITE_WIZARD_STEP_PATHS.LANGUAGE_COUNTRY,
      PMAX_LITE_WIZARD_STEP_PATHS.WEBSITE,
      PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_SIGNUP,
      PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_EDITOR,
      ...campaignCreationSteps,
      accountStep,
      ...paymentSteps,
    ];
  }

  if (isSkipCampaign) {
    return [
      ...initialStep,
      ...languageAndWebsiteStep,
      PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_MODE,
      accountStep,
      ...paymentSteps,
    ];
  }

  // default is pmax campaign creation flow
  return [
    ...initialStep,
    ...languageAndWebsiteStep,
    PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_MODE,
    ...campaignCreationSteps,
    accountStep,
    ...paymentSteps,
    PMAX_LITE_WIZARD_STEP_PATHS.CONVERSION_UPSELL,
  ];
};

export const convertStepIdForPreviewFlow = (isPreviewFlow, currentStepId) => {
  if (isPreviewFlow) {
    return NON_PREVIEW_TO_PREVIEW_MAPPING[currentStepId] || currentStepId;
  }
  return PREVIEW_TO_NON_PREVIEW_MAPPING[currentStepId] || currentStepId;
};

export const getSubFlowFromCurrentFlow = (currentFlow) => {
  // currentFlow is an array of step ids
  if (currentFlow.includes(PMAX_LITE_WIZARD_STEP_PATHS.FACEBOOK_IMPORT)) {
    return SIGNUP_SUB_FLOW.FacebookImport;
  }
  if (currentFlow.includes(PMAX_LITE_WIZARD_STEP_PATHS.GOOGLE_IMPORT)) {
    return SIGNUP_SUB_FLOW.GoogleImport;
  }
  if (currentFlow.includes(PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_SIGNUP)) {
    return SIGNUP_SUB_FLOW.SmartPage;
  }
  if (!currentFlow.includes(PMAX_LITE_WIZARD_STEP_PATHS.AD_ASSETS)
    && !currentFlow.includes(PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ASSETS)) {
    return SIGNUP_SUB_FLOW.SkipCampaign;
  }
  return SIGNUP_SUB_FLOW.CampaignCreation;
};
